import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChipFilterComponent } from './components';
import { AdvancedFilterContainerComponent } from './components/advanced-filter-container/advanced-filter-container.component';
import { DeviceStatusFilterComponent } from './components/device-status-filter/device-status-filter.component';
import { DeviceBundleFilterComponent } from './components/device-bundle-filter/device-bundle-filter.component';
import { MerchantsFilterComponent } from './components/merchants-filter/merchants-filter.component';
import { TerminalFilterComponent } from './components/terminal-filter/terminal-filter.component';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  declarations: [
    ChipFilterComponent,
    AdvancedFilterContainerComponent,
    DeviceStatusFilterComponent,
    DeviceBundleFilterComponent,
    MerchantsFilterComponent,
    TerminalFilterComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [ChipFilterComponent, AdvancedFilterContainerComponent, DeviceStatusFilterComponent, DeviceBundleFilterComponent, MerchantsFilterComponent, TerminalFilterComponent],
})
export class FiltersModule {}
